<template>
<!-- 录播课首页 -->
  <div id='main'>
    <ul @mousedown.stop.prevent='classListMove' ref="classList" >
      <li v-for="(item,index) of classList.courses" :key='index' @click.stop='liClickHandler(index)'>
        <div class="class-list" :class="{'active':clickLiIndex==index}">
          <img class='list-img' :src="require(`@/assets/images/courses/courses0${index}.png`)" :alt='`courses0${index}`' />
          <div class='list-info'>
            <h4 class='info-num'>{{titleList[index]}}</h4>
            <p class='info-title'>{{item.name.zh}}</p>
            <span class='progress-text'>{{item.completed}}/{{item.levels}}</span>
            <el-progress :percentage="(item.completed/item.levels)*100" :show-text='false'></el-progress>
          </div>
          <div class="class-list-up" v-show="item.locked">
            <img src="@/assets/images/no.png" alt="no"/>
          </div>
          <div class="class-list-up-ok" v-show="item.completed===item.levels">
            <img src="@/assets/images/ok.png" alt="no"/>
          </div>
        </div>
      </li>
    </ul>
    <div class="block ul-bar">
      <el-slider v-model = "sliderValue" :show-tooltip = "false"></el-slider>
    </div>
    <center-dialog 
      :centerDialogVisible.sync = "centerDialogVisible"
      :classList = "classList"
    ></center-dialog>
  </div>
</template>

<script>
import CenterDialog from '../components/classmain/CenterDialog'
export default{
  name: 'ClassMain',
  provide () {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      packageList: [],
      classList: {},
      clickLiIndex: -1,//course now clicked
      sliderValue: 0,
      sliderBool: false,//sliderValue监听silderBar是否起作用
      centerDialogVisible: false,//是否显示对话框
      mouseMoveX: 0,
      titleList: ['课前必读', '第一课', '第二课', '第三课', '第四课', '第五课', '第六课'],
      isRouterAlive: true
    }
  },
  components: {
    CenterDialog
  },
  async mounted () {
    await this.$store.dispatch("classAjaxHandler");
    this.packageList = this.$store.state.packageList;
    let id = this.$route.params.id;
    this.classList = this.packageList[id];
  },
  methods: {
    async classAjaxHandler () {
      let url = `/progress`;
      try{
        let request =  await this.axios.get(url);
        this.classList = request.data[0];
        console.log(this.classList)
      }catch(e){
        console.error(e)
      }
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    liClickHandler (index){
      this.clickLiIndex = index;
      if(this.mouseMoveX < 10){
        let courses = this.classList.courses[index];
        if(courses.locked){
          this.centerDialogVisible = true;
        }else{
          window.open(`/package/${this.classList._id}/course/${courses.courseId}`, "_self");
        }
      }
    },
    classListMove (e){
      let target = e.currentTarget;
      let disX = e.clientX - target.offsetLeft;
      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', up);
      let startClickX = e.clientX;
      let endClickX = -1;
      let _this = this;
      function move(e) {
        let left = e.clientX - disX;
        endClickX = e.clientX;
        if(left < 30 && left > -target.offsetWidth/2){
          this.positionX = left;
          target.style.left =  left + 'px';
          _this.sliderBool = true;
          _this.sliderValue = (left*100)/(-target.offsetWidth/2);
        }
      };
      function up(e) {
        _this.sliderBool = false;
        _this.mouseMoveX = endClickX === -1 ? 0 : Math.abs(endClickX - startClickX);
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', up);
      }
    }
  },
  watch: {
    sliderValue (curVal,oldVal) {
      if(!this.sliderBool){
        let targetUl = this.$refs.classList;
        targetUl.style.left = -((curVal*targetUl.offsetWidth/2)/100 - 30) + 'px';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#main{
  width: 100%;
  height: 580px;
  position: relative;
  margin-top: 60px;
  ul{
    display: flex;
    position: absolute;
    left: 30px;
    top: 30px;
    li{
      position: relative;
      .class-list.active{
          transform: scale(1.1);
          background: #fff;
          .list-info{
            .info-num{
              color: #fff;
              background: #ED6400;
            }
            .info-title{
              color:#ED6400;
            }
          }
        }
      .class-list{
        position: relative;
        width: 220px;
        height: 360px;
        background:rgb(217, 212, 246);
        border-radius:19px;
        margin: 20px;
        cursor: pointer;
        transition: all 1s;
        &:hover{
          transform: scale(1.1);
          background: #fff;
          .list-info{
            .info-num{
              color: #fff;
              background: #ED6400;
            }
            .info-title{
              color:#ED6400;
            }
          }
        }
        .list-img{
          width: 200px;
          height: 200px;
          border-radius: 8px;
          margin: 10px;
          /* box-shadow: 3px 3px 3px #888888; */
        }
        .list-info{
          overflow: hidden;
          border-radius: 19px;
          .info-num{
            width:98px;
            height:25px;
            font-size:15px;
            line-height: 25px;
            background:#dbbbc7;
            border-radius:13px;
            color:#ED6400;
            text-align: center;
            margin: 25px auto;
          }
          .info-title{
            font-size: 18px;
            color: #374048;
            text-align: center;
            margin-bottom: 32px;
          }
          .progress-text{
            position: absolute;
            right: 10px;
            bottom: 20px;
            font-size: 14px;
            color: #5FB0F5;
          }
        }
      }
      .class-list-up{
        width: 200px;
        height: 200px;
        background: url("~@/assets/images/level_up.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 10px;
        top: 10px;
        img{
          width: 50px;
          height: 60px;
          position: absolute;
          left: 78px;
          top: -36px;
        }
      }
      .class-list-up-ok{
        img{
          width: 70px;
          height: 55px;
          position: absolute;
          left: 76px;
          top: -36px;
        }
      }
    }
  }
  .waiting{
    color: #fff;
    font-size: 40px;
    margin: 100px auto;
    text-align: center;
  }
  .ul-bar{
    width: 400px;
    position: absolute;
    left: 50%;
    bottom: 60px;
    margin-left: -200px;
  }
  /deep/ .el-progress-bar__inner {
    background-color: #61ACF1 !important;
  }
  /deep/ .el-progress-bar__outer{
    background-color: #baccf4 !important;
  }
  /deep/ .el-slider__bar{
    background-color: #fff !important;
  }
  /deep/ .el-slider__runway{
    background-color: #b8b7ed !important;
  }
  /deep/ .el-slider__button-wrapper {
    top: -53px !important;
  }
  /deep/ .el-slider__button{
    width: 45px !important;
    height: 73px !important;
    border: none !important;
    background: url('~@/assets/images/bar_mark.png') no-repeat !important;
    background-size: 100% 95% !important;
  }
}
</style>




